// @flow

import React from 'react'
import type { Node } from 'react'

type Props = {
  children: Node,
}

const A11yDescription = ({ children }: Props) => (
  <span className="hide">{children}</span>
)

export default A11yDescription



// WEBPACK FOOTER //
// ./src/components/helpers/a11y-description.js